/* @flow */

import { SECONDS_PER_MINUTE } from '../../../helpers/dateTime/Format';
import Localizer from '../../../helpers/localization';
import { OtpResponseKind } from '../../../helpers/parentalControl/constsAndTypes';
import { PinModalKind } from './PinModalConstsAndTypes';

const isValidOtp = (otp: string): boolean => /^\d{6}$/iu.test(otp);

const isValidPinCode = (pin: string): boolean => /^\d{4}$/iu.test(pin);

const getMessageFromStatus = (status: OtpResponseKind): string => {
  switch (status) {
    case OtpResponseKind.CodeNotSet:
      return Localizer.localize('settings.parental_control.otp_error.code_not_set');

    case OtpResponseKind.OtpNotSet:
      return Localizer.localize('settings.parental_control.otp_error.not_set');

    case OtpResponseKind.WrongOtp:
      return Localizer.localize('settings.parental_control.otp_error.wrong_otp');

    case OtpResponseKind.OtpExpired:
      return Localizer.localize('settings.parental_control.otp_error.otp_expired');

    case OtpResponseKind.Error:
    default:
      return Localizer.localize('settings.parental_control.otp_error.unexpected_error');
  }
};

const getDelayFromRetryAfter = (retryAfter: number, oneSecondAllowed?: boolean): number => {
  if (retryAfter === 0) {
    // 0: no message
    return 0;
  }

  if (retryAfter === 1 && oneSecondAllowed !== true) {
    // 0: no message
    return 0;
  }

  if (retryAfter < SECONDS_PER_MINUTE) {
    // Return retryAfter as it is (in seconds)
    return retryAfter;
  }

  // Return retryAfter in minutes, rounded to the nearest minute
  return Math.round(retryAfter / SECONDS_PER_MINUTE);
};

// Parameter retryAfter is in seconds
const getErrorMessage = (kind: PinModalKind, retryAfter: number, tooManyRequests?: boolean, oneSecondAllowed?: boolean): string => {
  if (kind === PinModalKind.UnlockProfile) {
    return Localizer.localize('settings.parental_control.invalid_profile_pin');
  }

  if (tooManyRequests && retryAfter === 0) {
    return '';
  }

  const segment = tooManyRequests ? 'too_many_requets' : 'invalid_master_pin';
  const key = retryAfter < SECONDS_PER_MINUTE ? `settings.parental_control.${segment}.retry_second` : `settings.parental_control.${segment}.retry_minute`;
  const count = getDelayFromRetryAfter(retryAfter, oneSecondAllowed);

  return Localizer.localize(key, { count });
};

export { getErrorMessage, getMessageFromStatus, isValidOtp, isValidPinCode };
